export const initialValues = {
    personalInformation: {
        addressLineOne: '',
        addressLineTwo: '',
        addressLineThree: '',
        postcode: '',
        employmentStatus: '',
        maritalStatus: '',
        nationalInsuranceNumber: '',
    },
};

export const employmentStatuses = [
    'Employed',
    'Self employed',
    'Carer',
    'In full time education',
    'In receipt of pension',
    'Not employed',
];

export const employmentStatusOptions = employmentStatuses.map(value => ({
    label: value,
    value,
}));

export const maritalStatuses = ['Single', 'Married', 'Civil Partner', 'Divorced', 'Separated', 'Widowed'];

export const maritalStatusOptions = maritalStatuses.map(value => ({
    label: value,
    value,
}));
